var render, staticRenderFns
import script from "./canvas-poster.vue?vue&type=script&lang=js&"
export * from "./canvas-poster.vue?vue&type=script&lang=js&"
import style0 from "./canvas-poster.vue?vue&type=style&index=0&id=32b53ae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b53ae9",
  null
  
)

export default component.exports